import { inject, Injectable } from "@angular/core";
import { DataService } from "@core/data";
import { Observable } from "rxjs";
import { Remitter } from "../models/remitter.model";

const REMITTER_ENDPOINT = (serviceEntityId: string, clientId: string): string =>
	`/proxy/remitter/service-entity/${serviceEntityId}/client/${clientId}`;

@Injectable({
	providedIn: "root"
})
export class RemitterService {
	private readonly dataService = inject(DataService);

	public loadRemitters(serviceEntityId: string, clientId: string): Observable<Remitter[]> {
		return this.dataService.get<Remitter[]>(REMITTER_ENDPOINT(serviceEntityId, clientId));
	}
}
